module.exports = __webpack_public_path__ + "assets/img/title-61c8df9a.png";